/**
 * Shared V2 shell for marketplace listing sub-pages (create, detail, edit).
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaChevronLeft, FaShoppingBag } from 'react-icons/fa';
import './camp-essentials-shell.css';
import './camp-essentials-gear.css';
import './community-listing-pages.css';

export function CommunityListingPageShell({
  backLabel = 'Marketplace',
  backTo = '/camp-essentials/gear?tab=listings',
  title,
  subtitle,
  testId,
  children,
}) {
  const navigate = useNavigate();

  return (
    <div className="camp-essentials-shell community-listing-page" data-testid={testId}>
      <svg className="camp-essentials-shell__bg-grid" aria-hidden="true">
        <defs>
          <pattern
            id="community-listing-page-grid"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#community-listing-page-grid)" />
      </svg>

      <div className="camp-essentials-shell__inner community-listing-page__inner">
        <button
          type="button"
          className="camp-essentials-gear__back"
          onClick={() => navigate(backTo)}
        >
          <FaChevronLeft size={12} aria-hidden="true" />
          {backLabel}
        </button>

        <header className="community-listing-page__header">
          <div className="camp-essentials-shell__header-main">
            <div className="camp-essentials-shell__header-icon" aria-hidden="true">
              <FaShoppingBag size={18} />
            </div>
            <div>
              <h1 className="camp-essentials-shell__title">{title}</h1>
              {subtitle ? <p className="camp-essentials-shell__subtitle">{subtitle}</p> : null}
            </div>
          </div>
        </header>

        <div className="community-listing-page__panel">{children}</div>
      </div>
    </div>
  );
}
